import { useState } from "react";
import Api from "../functions/Api";
import { ValidationResponse } from "../functions/validation";

const useConsultaClientes = ({ handleMuestraSnack }) => {
  const [ejecutaapi] = Api();
  const [lotesCliente, setLotesCliente] = useState([]);
  const [movimientosLote, setMovimientosLote] = useState([]);
  const [amortizacionxlote, setAmortizacionxLote] = useState([]);


  const usuario = localStorage.getItem("user");

  



  const getLotesxCliente = (idCliente)=> {
    //setLotesCliente([]);
    let body = JSON.stringify({ idCliente: idCliente });
    ejecutaapi("obtieneLotesXCliente", body).then(data => {
      let { result, error } = ValidationResponse(data);

      if (error !== "") handleMuestraSnack(error, "error");
        setLotesCliente(result);

    });
  };


  const getMovimientosxLote = (idLote,fecIni,fecFin)=> {
    //setLotesCliente([]);
    let body = JSON.stringify({ idLote: idLote , fecIni:fecIni, fecFin:fecFin});
    ejecutaapi("obtieneMovimientosxLotes", body).then(data => {
      let { result, error } = ValidationResponse(data);

      if (error !== "") handleMuestraSnack(error, "error");
      setMovimientosLote(result);
    });
  };

  const getAmortizacionxLote = (idContrato)=> {
    //setLotesCliente([]);
    let body = JSON.stringify({opt:0, idContrato: idContrato });
    ejecutaapi("obtieneTblAmortizacion", body).then(data => {
      let { result, error } = ValidationResponse(data);

      if (error !== "") handleMuestraSnack(error, "error");

let tblAmort=[];
for(let i=0;i<result.length;i++){

  const uno = JSON.parse(result[i].JTEMP.replace(/\\"/g, '"'));

  tblAmort.push(uno);
};


      setAmortizacionxLote(tblAmort);
    });
  };

 

  return {
    lotesCliente,
    setLotesCliente,
    getLotesxCliente,
    
    getMovimientosxLote,
    movimientosLote,
    setMovimientosLote,

    getAmortizacionxLote,
    amortizacionxlote,
    setAmortizacionxLote
  };
};

export default useConsultaClientes;
